import { FaqListItem } from "../FaqListItem";
import "./ProductInformation.css";

type ProductInformationItem = {
  title: string;
  description: unknown;
};

export const ProductInformation = ({
  informationItems,
  title,
}: {
  title: string;
  informationItems: ProductInformationItem[];
}) => {
  return informationItems.length ? (
    <section className="react-pdp__onetime-about-mobile">
      <h2 className="react-pdp__onetime-about-title">
        <span>Über</span> {title}
      </h2>
      <div className="react-pdp__onetime-faq-list">
        {informationItems.map((item, index) => (
          <FaqListItem
            description={item.description}
            key={`${item.title}-${index}`}
            title={item.title}
          />
        ))}
      </div>
    </section>
  ) : null;
};
